<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="voie?.num" 
[label]="step12.getnum"
[type]="'text'" [rule]="'required|minSize_1|maxSize_50'"
[errorMessage]="{'required' : 'ctr_1031_jira'}"
[name]="getUid()+'_SepAtt_num'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="voie?.typevoie" 
[label]="step12.gettypevoie"
[type]="'text'" [rule]="'required|minSize_1|maxSize_255'"
[name]="getUid()+'_SepAtt_typevoie'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="voie?.nomvoie" 
[label]="step12.getnomvoie"
[type]="'text'" [rule]="'required|minSize_5|maxSize_1000'"
[name]="getUid()+'_SepAtt_nomvoie'">
</app-form-input>